<template>
  <div class="modal fade" id="loginModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content axion-modal p-4">
        <!-- Header -->
        <div class="text-center mb-4">
          <i class="bi bi-person-circle display-4 text-pink glow-text"></i>
          <h4 class="mt-2 glow-text">Welcome</h4>
          <p class="text-muted small">Login to continue</p>
        </div>

        <!-- Email -->
        <div class="input-group mb-3 axion-input">
          <span class="input-group-text">
            <i class="bi bi-envelope-fill text-pink"></i>
          </span>
          <input
            type="email"
            class="form-control"
            placeholder="Enter your email"
            v-model="email"
          />
        </div>

        <!-- Password -->
        <div class="input-group mb-3 axion-input">
          <span class="input-group-text">
            <i class="bi bi-lock-fill text-pink"></i>
          </span>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            placeholder="Enter your password"
            v-model="password"
          />
          <span
            class="input-group-text"
            @click="togglePassword"
            style="cursor: pointer"
          >
            <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
          </span>
        </div>

        <!-- Options -->
        <div
          class="d-flex justify-content-between align-items-center mb-3 small"
        >
          <div>
            <input type="checkbox" class="form-check-input me-1" />
            Remember me
          </div>
          <a href="#" class="text-pink text-decoration-none">Forgot?</a>
        </div>

        <!-- Message -->
        <p v-if="message" :class="messageClass" class="small text-center mb-2">
          {{ message }}
        </p>

        <!-- Button -->
        <button
          class="btn btn-pink w-100 py-2"
          :disabled="loading"
          @click="handleLogin"
        >
          <i class="bi bi-box-arrow-in-right me-2"></i>
          <span v-if="loading">Logging in...</span>
          <span v-else>Login</span>
        </button>
        <button
          ref="closeBtn"
          type="button"
          data-bs-dismiss="modal"
          style="display: none"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      message: "",
      messageClass: "",
      loading: false,
    };
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    getDevice() {
      const ua = navigator.userAgent;
      if (/Windows/i.test(ua)) return "Windows";
      if (/Macintosh|Mac OS X/i.test(ua)) return "Mac";
      if (/iPhone/i.test(ua)) return "iPhone";
      if (/Android/i.test(ua)) return "Android";
      if (/Linux/i.test(ua)) return "Linux";
      return "Unknown";
    },

    getBrowser() {
      const ua = navigator.userAgent;
      if (ua.indexOf("Firefox") > -1) return "Firefox";
      if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) return "Opera";
      if (ua.indexOf("Trident") > -1) return "Internet Explorer";
      if (ua.indexOf("Edge") > -1) return "Edge";
      if (ua.indexOf("Chrome") > -1) return "Chrome";
      if (ua.indexOf("Safari") > -1) return "Safari";
      return "Unknown";
    },

    async handleLogin() {
      this.loading = true;
      this.message = "";

      try {
        const now = new Date();
        const loginTime =
          now.getFullYear() +
          "-" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(now.getDate()).padStart(2, "0") +
          " " +
          String(now.getHours()).padStart(2, "0") +
          ":" +
          String(now.getMinutes()).padStart(2, "0") +
          ":" +
          String(now.getSeconds()).padStart(2, "0");

        const response = await axios.post("/student-login", {
          email: this.email,
          password: this.password,
          login_time: loginTime,
          device: this.getDevice(),
          browser: this.getBrowser(),
        });

        if (response && response.data) {
          const { token, student } = response.data;
          localStorage.setItem("token", token);
          localStorage.setItem("firstName", student.first_name);
          localStorage.setItem("userId", student.id);

          this.message = "Login successful!";
          this.messageClass = "text-success";

          // Close modal using data-bs-dismiss
          this.$refs.closeBtn.click();

          // Go to dashboard
          this.$router.push("/studentDashboard");
        } else {
          this.message = "Unexpected response from server.";
          this.messageClass = "text-danger";
        }
      } catch (error) {
        console.error("Login error:", error);
        if (error.response) {
          this.message =
            "Login failed: " + (error.response.data.message || "Unknown error");
        } else if (error.request) {
          this.message = "Login failed: No response from server";
        } else {
          this.message = "Login failed: " + error.message;
        }
        this.messageClass = "text-danger";
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    const errorQuery = this.$route.query.error;
    if (errorQuery === "unauthorized") {
      this.message = "You have been logged out or your session expired.";
      this.messageClass = "text-danger";
    }
  },
};
</script>

<style lang="scss" scoped>
.axion-modal {
  background: linear-gradient(180deg, #1a001f, #0d0015);
  border: 1px solid #ff00cc;
  border-radius: 15px;
  color: white;
  box-shadow: 0 0 25px rgba(255, 0, 204, 0.3);
}

.text-pink {
  color: #ff00cc;
}

.glow-text {
  text-shadow: 0 0 10px #ff00cc, 0 0 20px #ff00cc;
}

.axion-input .input-group-text {
  background: #2b0033;
  border: 1px solid #ff00cc;
  border-right: none;
}

.axion-input .form-control {
  background: #120015;
  border: 1px solid #ff00cc;
  border-left: none;
  color: white;
}

.axion-input .form-control:focus {
  box-shadow: 0 0 10px #ff00cc;
  border-color: #ff00cc;
  background: #120015;
  color: white;
}

.btn-pink {
  background: linear-gradient(45deg, #ff00cc, #9900ff);
  border: none;
  color: white;
  transition: 0.3s;
  border-radius: 30px;
}

.btn-pink:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 15px #ff00cc;
}
</style>
